module.exports = __webpack_public_path__ + "media/honey-icons/icon-frost-protect-b9426786.svg";